import React from 'react';
import PropTypes from 'prop-types';
import {
  defineMessages,
  FormattedMessage,
  useIntl,
} from 'react-intl';
import classes from './signin-security.scss';
import { AnchorIntl } from 'components/intl';
import Toggle from 'components/toggle-view';
import EnrolledCheckImage from 'static/images/svg/enrolled-check.svg';

const t = defineMessages({
  'enhanced-security-mfa.enhanced-security': {
    id: 'enhanced-security-mfa.enhanced-security',
    defaultMessage: 'Enhanced Security',
    description: 'Title string for the enhanced security section',
  },
  'enhanced-security-mfa.enhanced-security.enable': {
    id: 'enhanced-security-mfa.enhanced-security.enable',
    defaultMessage: 'Enable enhanced security',
    description: 'Label string for the enable enhanced security slider control',
  },
  'enhanced-security-mfa.enhanced-security.information': {
    id: 'enhanced-security-mfa.enhanced-security.information',
    defaultMessage: 'This will provide an extra layer of security to verify the login by leveraging the paired MFA device.',
    description: 'Label string for the enable enhanced security slider control',
  },
  'enhanced-security-mfa.multi-factor-authentication': {
    id: 'enhanced-security-mfa.multi-factor-authentication',
    defaultMessage: 'Multi-factor authentication',
    description: 'Title string for the multi-factor authentication section',
  },
  'enhanced-security-mfa.paired-to-device': {
    id: 'enhanced-security-mfa.paired-to-device',
    defaultMessage: 'Paired to device',
    description: 'Label for indicating that the user has a paired device set up',
  },
  'enhanced-security-mfa.reset-for-new-device': {
    id: 'enhanced-security-mfa.reset-for-new-device',
    defaultMessage: 'Reset for a new device',
    description: 'Link text for resetting MFA using another device.',
  },
  'enhanced-security-mfa.set-up': {
    id: 'enhanced-security-mfa.set-up',
    defaultMessage: 'Set up',
    description: 'Link text for initiating the Enhanced Security option.',
  },
  'enhanced-security-mfa.status-on': {
    id: 'enhanced-security-mfa.status-on',
    defaultMessage: 'Enhanced security enabled',
    description: 'Hover text to display over the toggle control when the feature is enabled.',
  },
  'enhanced-security-mfa.status-off': {
    id: 'enhanced-security-mfa.status-off',
    defaultMessage: 'Enhanced security disabled',
    description: 'Hover text to display over the toggle control when the feature is disabled.',
  },
});

export const EnhancedSecurity = ({
   toggleEnhancedSecurity,
   resetDeviceOnClick,
   setUpEnhancedSecurityOnClick,
   meEnhancedSecurity,
   meTfaEnrolled,
 }) => {
  const intl = useIntl();
  return (
    <div className={classes['enhancedSecurity']}>
      <div className="row">
        <div id="enhanced-security-title" className="col-xs-12 sectionTitle">
          <FormattedMessage {...t['enhanced-security-mfa.enhanced-security']} />
        </div>
      </div>
      <div className="row">
        <div id="enhanced-security-mfa-info" className={`col-xs-8 ${classes['sectionInfo']}`}>
          <FormattedMessage {...t['enhanced-security-mfa.enhanced-security.enable']} />
        </div>
        <div id="enhanced-security-mfa-info" className={`col-xs-4 text-right ${classes['sectionInfo']}`}>
          {!meTfaEnrolled &&
            <AnchorIntl
              a={{
                href: '#',
                message: t['enhanced-security-mfa.set-up'],
                target: '_self',
                onClick: setUpEnhancedSecurityOnClick
              }}
            />}
          {meTfaEnrolled &&
            <Toggle
              id="enhancedSecurityToggle"
              name="enhancedSecurityToggle"
              isOn={meEnhancedSecurity}
              title={intl.formatMessage(t[`enhanced-security-mfa.status-${meEnhancedSecurity ? 'on' : 'off'}`])}
              defaultChecked
              onToggleClick={toggleEnhancedSecurity}
            />}
        </div>
      </div>
      <div className="row">
        <div id="enhanced-security-mfa-title" className={`col-xs-12 ${classes['staticFieldLabel']}`}>
          <div className={classes['borderTop']}>
            <FormattedMessage {...t['enhanced-security-mfa.enhanced-security.information']} />
          </div>
        </div>
      </div>
      {meTfaEnrolled &&
        <div>
          <div className="row">
            <div id="enhanced-security-mfa-title" className="col-xs-12 sectionTitle">
              <FormattedMessage {...t['enhanced-security-mfa.multi-factor-authentication']} />
            </div>
          </div>
          <div id="enhanced-security-enrolled-indicator" className={`row ${classes['mfaStatus']}`}>
            <div className={`col-xs-12 ${classes['status-indicator']}`}>
              <img
                src={EnrolledCheckImage}
                alt={intl.formatMessage(t['enhanced-security-mfa.paired-to-device'])}
              />
              <FormattedMessage {...t['enhanced-security-mfa.paired-to-device']} />
            </div>
            <div className={`col-xs-10 ${classes['actionLink']}`}>
              <AnchorIntl
                a={{
                  href: resetDeviceOnClick,
                  message: t['enhanced-security-mfa.reset-for-new-device'],
                  target: '_self'
                }}
              />
            </div>
          </div>
        </div>}
      {!meTfaEnrolled &&
        <div className={classes['mfaSpacer']}>
          &nbsp;
        </div>}
    </div>
  );
};

EnhancedSecurity.propTypes = {
  toggleEnhancedSecurity: PropTypes.func.isRequired,
  resetDeviceOnClick: PropTypes.string.isRequired,
  setUpEnhancedSecurityOnClick: PropTypes.func,
  meEnhancedSecurity: PropTypes.bool.isRequired,
  meTfaEnrolled: PropTypes.bool.isRequired,
};

export default EnhancedSecurity;
